import React, { CSSProperties } from 'react';

import { Button } from '@/components/Button/Button';
import { ButtonProps } from '@/components/Button/types';

const CourseCardCancelButtonStyle: CSSProperties = {
  position: 'absolute',
  right: 'var(--gap-xs)',
  top: 'var(--gap-xs)',
  zIndex: 20,
};

export const CourseCardCancelButton = (props: ButtonProps): JSX.Element => (
  <Button $type="baseInverted" $iconSize="lg" $size="small" $round $icon="times" style={CourseCardCancelButtonStyle} {...props} />
);
